import React from "react"
import PropTypes from "prop-types"
import { get, omit, flatMap } from "utils"
import { DEFAULT_THRESHOLD_NORMAL, DEFAULT_THRESHOLD_WIDE } from "constants/layout"
import { Radium, keyframes } from "higher-order-components"
import { GlobalNavLink, GlobalNavLinkSecondary } from "components"
import componentParser from "AtomicUtils/componentParser"

const getSections = (components, active) => ({
  primary: componentParser(components),
  secondary: flatMap(
    comp =>
      flatMap(({ name, props }) => {
        // @todo Hacky map to derive subcomponents needs refactor
        if (name === "FlexContent") {
          return get("components", props)
        }
        return null
      }, get("props.components", comp || {})),
    get("props.components", components[active] || {})
  )
})

const SubNavLarge = ({ navItems, activeItemIndex, toggleActive }) => {
  const { primary, secondary } = getSections(navItems.filter(item => item !== null), activeItemIndex)
  return (
    <div style={styles.wrapper} data-test="sub-nav-large">
      <div style={[styles.panel, styles.primaryPanel]}>
        {React.Children.map(primary, (comp, index) => {
          const childProps = {
            active: activeItemIndex === index,
            onClick: () => toggleActive(index),
            subNav: true
          }
          return (
            <div style={[styles.navLinkWrapper(index === 0)]} key={index}>
              <GlobalNavLink {...comp.props} {...childProps} />
            </div>
          )
        })}
      </div>
      <div style={[styles.panel, styles.secondaryPanel]}>
        {secondary.map(({ props }, index) => (
          <div style={[styles.navLinkWrapper(index === 0)]} key={index}>
            <GlobalNavLinkSecondary key={index} {...props} />
          </div>
        ))}
      </div>
    </div>
  )
}

SubNavLarge.propTypes = {
  navItems: PropTypes.array,
  activeItemIndex: PropTypes.number,
  toggleActive: PropTypes.func
}

export default Radium(SubNavLarge)

/** @todo transform animations disrupt initial menu open on IE 11, disable for now */
const linkAnimateIn = keyframes({
  from: {
    opacity: 0
    // transform: 'translateY(-50%)'
  },
  to: {
    opacity: 1
    // transform: 'translateY(0)'
  }
})

const breakpoint1 = `@media all and (min-width: ${DEFAULT_THRESHOLD_NORMAL +
  "px"}) and (max-width: ${DEFAULT_THRESHOLD_WIDE + "px"})`

const styles = {
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    height: "100%"
  },
  panel: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    boxSizing: "border-box",
    overflow: "hidden"
  },
  primaryPanel: {
    width: "32%",
    [breakpoint1]: {
      width: "40%"
    }
  },
  secondaryPanel: {
    textTransform: "none",
    width: "68%",
    backgroundColor: "#e6e6e6",
    padding: "0 2em 0 8vw",
    [breakpoint1]: {
      width: "60%"
    }
  },
  navLinkWrapper: isFirst => ({
    marginTop: isFirst ? "calc(12vw + .5em)" : 0
  }),
  animateIn: animDelay => ({
    opacity: 0,
    animation: `x .75s ${animDelay}s forwards`,
    animationName: linkAnimateIn
  })
}



// WEBPACK FOOTER //
// ./src/containers/global-nav/sub-nav-large.jsx